export default __webpack_public_path__ + "static/media/iqi_logo_and_name.39adb312.png";